import "./style.css";

import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import { Helmet } from "react-helmet";
import Home from "./Home/Home";
import SnowbirdPage from "./snowbird/SnowbirdPage";
import HalloweenPage from "./halloween/HalloweenPage";
import DecemberFormats from "./DecemberFormats/DecemberFormats";
import PageNotFound from "./PageNotFound";
import { useEffect } from "react";

export const MyRoutes = () => {
	return (
		<Routes>
			<Route path="/" element={<SnowbirdPage />} />
			<Route path="/halloween" element={<HalloweenPage />} />
			<Route path="/archive" element={<><Home /><Footer /></>} />
			<Route path="/formats" element={<DecemberFormats />} />
			{/* 404 Error */}
			<Route path="*" element={<PageNotFound />} />
		</Routes>
	);
};

function App() {
	// useEffect(() => {
	// 	// const script = document.createElement("script");

	// 	// script.src = "https://w.behold.so/widget.js";
	// 	// script.type = "module";
	// 	// script.async = true;

	// 	// document.body.appendChild(script);

	// 	return () => {
	// 		// document.body.removeChild(script);
	// 	};
	// }, []);

	return (
		<div className="App">
			<Helmet>
				<title>Sidewinder Grass Volleyball</title>
				<meta charSet="utf-8" />
				<meta
					name="description"
					content="Grass Volleyball Tournaments for all ages and skill levels in Tucson, Arizona"
				/>
			</Helmet>
			<div className="mainContainer">
				{/* <div className='topBanner' style={{display:'flex', justifyContent:"center"}}>
          <h4 style={{textAlign:"center"}}>15u-17u tryouts are at ASDB.  Times are posted on the <a href="/tryouts">tryout page</a></h4>
        </div> */}
				<Router>
					<div className="appContainer">
						<MyRoutes />
					</div>
				</Router>
			</div>
		</div>
	);
}

export default App;
